module.exports = __webpack_public_path__ + "img/games-16.cb89f7e4.jpg";